import { ViewFactory } from 'wdc-cube-solid'

import { registerViews as registerAccountViews } from './account'
import { registerViews as registerLandingViews } from './landing'
import { registerViews as registerMainViews } from './main'
import { registerViews as registerPatientDetailViews } from './generic/patient-detail'
import { registerViews as registerRestrictedViews } from './restricted'
import { registerViews as registerSharedHistoryViews } from './shared-history'

/**
 * O registro central de views.
 *
 * Um place nao nomeia o componente que o desenha: ele publica um scope, e o slot
 * resolve por esta tabela. E o que permite desenhar uma tela por vez sem a casca
 * conhecer nenhum modulo.
 *
 * Toda rota viva tem view desde que a paridade fechou (15/09/2026). O que faltar
 * aqui nao e etapa planejada, e DEFEITO: cai no `CannotOpen` do `v-main.tsx`, que
 * diz isso na tela e grita no console.
 */
export function registerAllViews() {
    const rv = ViewFactory.register

    registerMainViews(rv)
    registerLandingViews(rv)
    registerAccountViews(rv)
    registerRestrictedViews(rv)
    registerPatientDetailViews(rv)
    registerSharedHistoryViews(rv)
}
